export default __webpack_public_path__ + "static/media/bg_profile4.66f987b7.png";